import { Controller } from "@hotwired/stimulus"

const SELECT2_OPTIONS = {
  placeholder: "Select...",
  allowClear: false,
  width: "100%"
};

// jQuery's show() restores the computed display it recorded when it hid the element, which for
// both of these rows is "block" - measured, not assumed. The rejection panel starts hidden from
// the stylesheet, so restoring "" would leave it invisible.
const SHOWN = "block";
const HIDDEN = "none";

export default class extends Controller {
  static get targets() {
    return ["approved", "callToAction", "rejectionDetails", "affectedFields", "reasons"];
  }

  connect() {
    $(this.reasonsTarget).select2(SELECT2_OPTIONS);
    $(this.affectedFieldsTarget).select2(SELECT2_OPTIONS);
  }

  disconnect() {
    if (this.hasReasonsTarget) { $(this.reasonsTarget).select2("destroy"); }
    if (this.hasAffectedFieldsTarget) { $(this.affectedFieldsTarget).select2("destroy"); }
  }

  reject(event) {
    event.preventDefault();

    this.callToActionTarget.style.display = HIDDEN;
    this.approvedTarget.value = "false";
    this.rejectionDetailsTarget.style.display = SHOWN;
  }

  backToStatus(event) {
    event.preventDefault();

    this.rejectionDetailsTarget.style.display = HIDDEN;
    this.approvedTarget.value = "true";
    this.callToActionTarget.style.display = SHOWN;
  }
}
